import React from "react";
import Style from "./OrderPerviewList.module.css";
import { separate } from "../../Seprate/Seprate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBag } from "@fortawesome/free-solid-svg-icons";

const OrderPerviewList = ({ data }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return (
            <div className={Style.emptyHolder}>
                <FontAwesomeIcon
                    icon={faShoppingBag}
                    style={{ fontSize: "2rem", color: "#d1d5db" }}
                />
                <p className={Style.emptyText}>هیچ کالایی برای نمایش وجود ندارد</p>
            </div>
        );
    }

    const totalCount = data.reduce(
        (sum, item) => sum + parseInt(item.count || 1, 10),
        0
    );

    const totalPrice = data.reduce((sum, item) => {
        const price = parseInt(item.price || item.new_price || 0, 10);
        const count = parseInt(item.count || 1, 10);
        return sum + price * count;
    }, 0);

    return (
        <div className={Style.container}>
            {/* Header Summary */}
            <div className={Style.headerSummary}>
                <span>اقلام سفارش:</span>
                <span>
                    {data.length} قلم ({totalCount} عدد)
                </span>
            </div>

            {/* Products List */}
            <ul className={Style.listHolder}>
                {data.map((item, index) => {
                    const count = parseInt(item.count || 1, 10);
                    const unitPrice = parseInt(item.price || item.new_price || 0, 10);
                    const itemTotal = unitPrice * count;
                    const productName = item.current_name || item.name || "محصول بدون نام";

                    return (
                        <li key={item.product_id || index} className={Style.productCard}>
                            <div className={Style.rightPart}>
                                <div className={Style.imgHolder}>
                                    <img
                                        src={`//cdn.barest.ir/product/m/${item.product_id}.jpg`}
                                        alt={productName}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/Assets/Images/Order/not2.png";
                                        }}
                                    />
                                </div>
                                <div className={Style.infoHolder}>
                                    <h4 className={Style.productTitle} title={productName}>
                                        {productName}
                                    </h4>
                                    {item.p_product_id && String(item.p_product_id) !== "0" && item.p_name && (
                                        <div style={{ fontSize: "0.72rem", color: "#b45309", display: "flex", gap: "0.3rem", alignItems: "center" }}>
                                            <span style={{ color: "#9ca3af" }}>جایگزین:</span>
                                            <span style={{ textDecoration: "line-through", color: "#6b7280" }}>{item.p_name}</span>
                                        </div>
                                    )}
                                    <div className={Style.countBadge}>
                                        <span>تعداد:</span>
                                        <span className={Style.countNum}>{count}</span>
                                        <span>عدد</span>
                                    </div>
                                </div>
                            </div>

                            <div className={Style.leftPart}>
                                <div className={Style.priceText}>
                                    <span>{separate(unitPrice)}</span>
                                    <small>تومان</small>
                                </div>
                                {count > 1 && (
                                    <span className={Style.totalPriceSub}>
                                        مجموع: {separate(itemTotal)} تومان
                                    </span>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>

            {/* Footer Total Summary */}
            {totalPrice > 0 && (
                <div className={Style.footerSummary}>
                    <span className={Style.footerLabel}>مجموع مبلغ محصولات:</span>
                    <span className={Style.footerValue}>
                        {separate(totalPrice)} <small>تومان</small>
                    </span>
                </div>
            )}
        </div>
    );
};

export default OrderPerviewList;